import React from 'react';
import {ScratchListItem} from '../service';
import {Button} from '@/components-v2';
import {useTranslation} from 'react-i18next';
import {CurrencyMap} from '@services/currency';
import {Skeleton} from 'antd-mobile';
import {goTo} from '@utils';

const scratchCardStyle = {
  width: 'calc((100% - 0.5rem) / 2)',
  height: '9.625rem',
};

const ScratdhCard = ({v, i}: {v: ScratchListItem | null; i: number}) => {
  const {t} = useTranslation();
  const coverStyle = React.useMemo(() => {
    if (v?.cover) {
      return {
        '--width': '100%',
        '--height': '100%',
        backgroundImage: `url(${v.cover})`,
        backgroundSize: '100% 100%',
      } as React.CSSProperties;
    }
    return {
      '--width': '100%',
      '--height': '100%',
    } as React.CSSProperties;
  }, [v?.cover]);

  const goToGame = (id: any) => {
    goTo('Scratch', {
      path: 'detail/' + id,
      hideInnerTitle: '1',
    });
  };
  return (
    <div
      key={i}
      className="rounded-lg flex flex-col overflow-hidden relative"
      style={scratchCardStyle}
      onClick={() => {
        if (v) {
          goToGame(v.id);
        }
      }}>
      {!!v?.freeTicketNum && (
        <div className="bg-[#cf0000] text-white absolute top-0 left-0 py-1 px-2 rounded-br-lg text-sm font-extrabold z-[5]">
          Free
        </div>
      )}
      <Skeleton
        className="bg-center bg-no-repeat flex-1"
        animated
        style={coverStyle}
      />

      <div className="h-[2.5rem] bg-white px-2 flex flex-row justify-between items-center">
        <div>
          <p className="text-xs font-bold text-main text-ellipsis text-nowrap overflow-hidden">
            {v ? v.name : ''}
          </p>
          <div className="flex items-baseline">
            <p className="text-xs font-bold text-acc">
              {v ? CurrencyMap.default : ''}
              {v ? v.price : ''}
            </p>
          </div>
        </div>
        {v && (
          <Button
            onClick={() => goToGame(v.id)}
            className="bg-transparent border-1 rounded border-text-sec-acc h-6 min-w-0 px-2 text-xs font-medium">
            {t('home.label.tryNow')}
          </Button>
        )}
      </div>
    </div>
  );
};

export default ScratdhCard;
